import { render, staticRenderFns } from "./BotaoTexto.vue?vue&type=template&id=ad2eac3e&scoped=true"
import script from "./BotaoTexto.vue?vue&type=script&lang=js"
export * from "./BotaoTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2eac3e",
  null
  
)

export default component.exports